module.exports = __webpack_public_path__ + "static/media/line-straight-icon.66ee8c50.svg";